import { FC } from 'react';
import { desktopOnlyCopy } from './desktopOnlyCopy';

export const DesktopOnlyHint: FC<{ className?: string }> = ({ className = '' }) => (
  <span className={`font-lureo-font-ui text-lureo-14 leading-snug text-lureo-ink-subtle ${className}`}>
    {desktopOnlyCopy.heading}
  </span>
);
